import isEmpty from 'lodash.isempty'

export const selectConsentDetailsForIsoCode = ({ isoCodeToAge, isoCodeToStandard }, isoCode = 'US') => {
  return isoCode ? {
    isoCode,
    standard: !isEmpty(isoCodeToStandard) ? isoCodeToStandard[isoCode.toUpperCase()] : '',
    age: !isEmpty(isoCodeToAge) ? isoCodeToAge[isoCode.toUpperCase()] : '',
  } : null
}
